import { IS_NATIVE_PLATFORM } from "./platform";
export const FEATURE_FLAG_IDS_COMMON = {
    GROWTHBOOK_LOADED: "growthbook_loaded",
};
export const FEATURE_FLAG_IDS_WEB = {
    TTS: "tts_web",
    KINDE_NEW_LOGIN: "KINDE_NEW_LOGIN",
    POC_BETA_USER: "poc_beta_test",
    ONBOARDING_FLOW_V2: "onboarding_flow_v2",
    CHATBOT_PROFILE_V2: "chatbot_profile_v2_web",
    MY_CHATBOTS_V2: "mychatbots_v2_web",
    CREATE_PERSONA_V2: "createPersona_v2_web",
    FILTER_LANGUAGE: "release_filter_language_web",
    FILTER_DEFINITION: "filter_definition_web",
    MY_PERSONAS_V2: "my_personas_v2_web",
    CHAT_NEW_INFRA: "chat_new_endpoint",
    LOREBOOK_IMPORT: "lorebook_import",
    LOREBOOK_PUBLIC: "lorebook_public_web",
    LOREBOOK_DISCOVER_PUBLIC: "lorebook_discover_public_web",
    LOREBOOK_DETAIL: "NX-5637-lorebook-web",
    // Gates the FE staged-edit / pending-moderation flow for edits to already-PUBLIC lorebooks.
    // Mirrors the backend `lorebook_public_edit_moderation` gate and the character-side
    // PUBLIC_BOT_EDIT_MODERATION flag. OFF: entry/parent edits go live immediately (legacy).
    LOREBOOK_PUBLIC_EDIT_MODERATION: "lorebook_public_edit_moderation_web",
    GROUPCHAT: "groupchat_web",
    CHAT_USER_IMAGE: "NX-3655-chat_user_image_web",
    CHARACTER_LISTING_V2: "character_listing_v2_web",
    CONVERSATION_IMAGE_GENERATION_FLUX: "NX-5088-conversation_image_generation_flux-web",
    MULTI_LANG_ENABLED: "multi_lang_enabled_web",
    SELECT_LOREBOOK_KEYWORD: "NX-5637-lorebook-web",
    CONVERSATION_IMAGE_GENERATION_QWEN: "NX-5683-conversation_image_generation_qwen-web",
    CHAT_INPUT_V2: "NX-5603_chat_input_v2_web",
    STORYMODE: "storymode_web",
    GENERATION_PRESETS: "generation_presets_web",
    RECOMBEE_VIEW_PORTIONS: "recombee-view-portions_web",
    CONTEXT_CAP_UPSELL: "NX-6669-context_cap_upsell_web",
    PUBLIC_BOT_EDIT_MODERATION: "public_bot_edit_moderation_web",
    CREATOR_ANALYTICS: "creator_analytics_web",
    RELEASE_GROUP_LOREBOOK_ATTACHMENT_WEB: "release_group_lorebook_attachment_web",
    CHARACTER_VOICE_ATTACHMENT: "character_voice_attachment_web",
    CUSTOM_VOICE_GREETING_PLAYBACK: "NX-10815_custom_voice_greeting_playback_web",
    HIDE_SIDEBAR_PAGES: "ab_hide_sidebar_pages_web",
};
export const FEATURE_FLAG_IDS_NATIVE = {
    CHATBOT_PROFILE_V2: "chatbot_profile_v2_native",
    CREATE_PERSONA_V2: "createPersona_v2_native",
    AICQ_CHARACTER_MODERATION: "aicq_character_moderation_native",
    CHARACTER_TRANSLATION: "character_translation_native",
    OPTIONAL_NAME_INPUT: "optional_name_input_native",
    LOREBOOK_IMPORT: "lorebook-import-native",
    LOREBOOK_PUBLIC: "lorebook_public_native",
    LOREBOOK_DISCOVER_PUBLIC: "lorebook_discover_public_native",
    LOREBOOK_DETAIL: "NX-5637-lorebook-native",
    LOREBOOK_PUBLIC_EDIT_MODERATION: "lorebook_public_edit_moderation_web",
    GROUPCHAT: "groupchat_native",
    FILTER_DEFINITION: "filter_definition_native",
    FILTER_LANGUAGE: "release_filter_language_native",
    SELECT_LOREBOOK_KEYWORD: "NX-5637-lorebook-native",
    CHAT_USER_IMAGE: "NX-5843-chat_user_image_native",
    TTS: "tts_native",
    PUBLIC_BOT_EDIT_MODERATION: "public_bot_edit_moderation_web",
    CHARACTER_VOICE_ATTACHMENT: "character_voice_attachment_native",
    CUSTOM_VOICE_GREETING_PLAYBACK: "NX-10815_custom_voice_greeting_playback_native",
    RELEASE_GROUP_LOREBOOK_ATTACHMENT_NATIVE: "release_group_lorebook_attachment_native",
    HIDE_SIDEBAR_PAGES: "ab_hide_sidebar_pages_native",
};
export const FEATURE_FLAGS_WEB = {
    GROWTHBOOK_LOADED: FEATURE_FLAG_IDS_COMMON.GROWTHBOOK_LOADED,
    TTS: FEATURE_FLAG_IDS_WEB.TTS,
    KINDE_NEW_LOGIN: FEATURE_FLAG_IDS_WEB.KINDE_NEW_LOGIN,
    POC_BETA_USER: FEATURE_FLAG_IDS_WEB.POC_BETA_USER,
    ONBOARDING_FLOW_V2: FEATURE_FLAG_IDS_WEB.ONBOARDING_FLOW_V2,
    CHATBOT_PROFILE_V2: FEATURE_FLAG_IDS_WEB.CHATBOT_PROFILE_V2,
    MY_CHATBOTS_V2: FEATURE_FLAG_IDS_WEB.MY_CHATBOTS_V2,
    CREATE_PERSONA_V2: FEATURE_FLAG_IDS_WEB.CREATE_PERSONA_V2,
    FILTER_LANGUAGE: FEATURE_FLAG_IDS_WEB.FILTER_LANGUAGE,
    FILTER_DEFINITION: FEATURE_FLAG_IDS_WEB.FILTER_DEFINITION,
    MY_PERSONAS_V2: FEATURE_FLAG_IDS_WEB.MY_PERSONAS_V2,
    CHAT_NEW_INFRA: FEATURE_FLAG_IDS_WEB.CHAT_NEW_INFRA,
    LOREBOOK_IMPORT: FEATURE_FLAG_IDS_WEB.LOREBOOK_IMPORT,
    LOREBOOK_PUBLIC: FEATURE_FLAG_IDS_WEB.LOREBOOK_PUBLIC,
    LOREBOOK_DISCOVER_PUBLIC: FEATURE_FLAG_IDS_WEB.LOREBOOK_DISCOVER_PUBLIC,
    LOREBOOK_DETAIL: FEATURE_FLAG_IDS_WEB.LOREBOOK_DETAIL,
    LOREBOOK_PUBLIC_EDIT_MODERATION: FEATURE_FLAG_IDS_WEB.LOREBOOK_PUBLIC_EDIT_MODERATION,
    GROUPCHAT: FEATURE_FLAG_IDS_WEB.GROUPCHAT,
    CHAT_USER_IMAGE: FEATURE_FLAG_IDS_WEB.CHAT_USER_IMAGE,
    CHARACTER_LISTING_V2: FEATURE_FLAG_IDS_WEB.CHARACTER_LISTING_V2,
    CONVERSATION_IMAGE_GENERATION_FLUX: FEATURE_FLAG_IDS_WEB.CONVERSATION_IMAGE_GENERATION_FLUX,
    MULTI_LANG_ENABLED: FEATURE_FLAG_IDS_WEB.MULTI_LANG_ENABLED,
    SELECT_LOREBOOK_KEYWORD: FEATURE_FLAG_IDS_WEB.SELECT_LOREBOOK_KEYWORD,
    CONVERSATION_IMAGE_GENERATION_QWEN: FEATURE_FLAG_IDS_WEB.CONVERSATION_IMAGE_GENERATION_QWEN,
    CHAT_INPUT_V2: FEATURE_FLAG_IDS_WEB.CHAT_INPUT_V2,
    STORYMODE: FEATURE_FLAG_IDS_WEB.STORYMODE,
    GENERATION_PRESETS: FEATURE_FLAG_IDS_WEB.GENERATION_PRESETS,
    RECOMBEE_VIEW_PORTIONS: FEATURE_FLAG_IDS_WEB.RECOMBEE_VIEW_PORTIONS,
    CONTEXT_CAP_UPSELL: FEATURE_FLAG_IDS_WEB.CONTEXT_CAP_UPSELL,
    PUBLIC_BOT_EDIT_MODERATION: FEATURE_FLAG_IDS_WEB.PUBLIC_BOT_EDIT_MODERATION,
    CREATOR_ANALYTICS: FEATURE_FLAG_IDS_WEB.CREATOR_ANALYTICS,
    RELEASE_GROUP_LOREBOOK_ATTACHMENT_WEB: FEATURE_FLAG_IDS_WEB.RELEASE_GROUP_LOREBOOK_ATTACHMENT_WEB,
    CHARACTER_VOICE_ATTACHMENT: FEATURE_FLAG_IDS_WEB.CHARACTER_VOICE_ATTACHMENT,
    CUSTOM_VOICE_GREETING_PLAYBACK: FEATURE_FLAG_IDS_WEB.CUSTOM_VOICE_GREETING_PLAYBACK,
    HIDE_SIDEBAR_PAGES: FEATURE_FLAG_IDS_WEB.HIDE_SIDEBAR_PAGES,
};
export const FEATURE_FLAGS_NATIVE = {
    GROWTHBOOK_LOADED: FEATURE_FLAG_IDS_COMMON.GROWTHBOOK_LOADED,
    CHATBOT_PROFILE_V2: FEATURE_FLAG_IDS_NATIVE.CHATBOT_PROFILE_V2,
    CREATE_PERSONA_V2: FEATURE_FLAG_IDS_NATIVE.CREATE_PERSONA_V2,
    AICQ_CHARACTER_MODERATION: FEATURE_FLAG_IDS_NATIVE.AICQ_CHARACTER_MODERATION,
    CHARACTER_TRANSLATION: FEATURE_FLAG_IDS_NATIVE.CHARACTER_TRANSLATION,
    OPTIONAL_NAME_INPUT: FEATURE_FLAG_IDS_NATIVE.OPTIONAL_NAME_INPUT,
    LOREBOOK_IMPORT: FEATURE_FLAG_IDS_NATIVE.LOREBOOK_IMPORT,
    LOREBOOK_PUBLIC: FEATURE_FLAG_IDS_NATIVE.LOREBOOK_PUBLIC,
    LOREBOOK_DISCOVER_PUBLIC: FEATURE_FLAG_IDS_NATIVE.LOREBOOK_DISCOVER_PUBLIC,
    LOREBOOK_DETAIL: FEATURE_FLAG_IDS_NATIVE.LOREBOOK_DETAIL,
    LOREBOOK_PUBLIC_EDIT_MODERATION: FEATURE_FLAG_IDS_NATIVE.LOREBOOK_PUBLIC_EDIT_MODERATION,
    GROUPCHAT: FEATURE_FLAG_IDS_NATIVE.GROUPCHAT,
    FILTER_DEFINITION: FEATURE_FLAG_IDS_NATIVE.FILTER_DEFINITION,
    FILTER_LANGUAGE: FEATURE_FLAG_IDS_NATIVE.FILTER_LANGUAGE,
    SELECT_LOREBOOK_KEYWORD: FEATURE_FLAG_IDS_NATIVE.SELECT_LOREBOOK_KEYWORD,
    CHAT_USER_IMAGE: FEATURE_FLAG_IDS_NATIVE.CHAT_USER_IMAGE,
    TTS: FEATURE_FLAG_IDS_NATIVE.TTS,
    PUBLIC_BOT_EDIT_MODERATION: FEATURE_FLAG_IDS_NATIVE.PUBLIC_BOT_EDIT_MODERATION,
    CHARACTER_VOICE_ATTACHMENT: FEATURE_FLAG_IDS_NATIVE.CHARACTER_VOICE_ATTACHMENT,
    CUSTOM_VOICE_GREETING_PLAYBACK: FEATURE_FLAG_IDS_NATIVE.CUSTOM_VOICE_GREETING_PLAYBACK,
    RELEASE_GROUP_LOREBOOK_ATTACHMENT_NATIVE: FEATURE_FLAG_IDS_NATIVE.RELEASE_GROUP_LOREBOOK_ATTACHMENT_NATIVE,
    HIDE_SIDEBAR_PAGES: FEATURE_FLAG_IDS_NATIVE.HIDE_SIDEBAR_PAGES,
};
export const FEATURE_FLAGS = (IS_NATIVE_PLATFORM ? FEATURE_FLAGS_NATIVE : FEATURE_FLAGS_WEB);
